class HeroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'));
    this.prevButton = this.querySelector('.hero-slideshow__arrow--prev');
    this.nextButton = this.querySelector('.hero-slideshow__arrow--next');
    this.autoplayButton = this.querySelector('.hero-slideshow__autoplay');
    this.currentIndex = 0;
    this.timer = null;
    this.speed = parseInt(this.dataset.speed, 10) || 6000;
    this.autoRotate = this.dataset.autoRotate === 'true' && this.slides.length > 1;
  }

  connectedCallback() {
    if (this.slides.length === 0) return;

    this.setActive(0, { restart: false });
    this.classList.add('is-initialized');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10)));
    });
    if (this.autoplayButton) {
      this.autoplayButton.addEventListener('click', () => this.toggleAutoplay());
    }

    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
      if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopTimer();
      } else if (this.autoRotate) {
        this.startTimer();
      }
    });

    if (this.autoRotate) {
      this.classList.add('is-playing');
      this.startTimer();
    }
  }

  disconnectedCallback() {
    this.stopTimer();
  }

  goTo(index) {
    const total = this.slides.length;
    const nextIndex = (index + total) % total;
    this.setActive(nextIndex);
    if (this.autoRotate) this.startTimer();
  }

  setActive(index, { restart = true } = {}) {
    const previousSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[index];

    if (previousSlide && previousSlide !== nextSlide) {
      previousSlide.classList.remove('is-active');
      previousSlide.setAttribute('aria-hidden', 'true');
      this.pauseVideo(previousSlide);
    }

    if (restart) {
      // Force reflow so the Ken Burns animation restarts from scratch each cycle.
      // eslint-disable-next-line no-unused-expressions
      nextSlide.offsetWidth;
    }

    nextSlide.classList.add('is-active');
    nextSlide.setAttribute('aria-hidden', 'false');
    this.playVideo(nextSlide);

    this.dots.forEach((dot) => {
      dot.classList.toggle('is-active', parseInt(dot.dataset.index, 10) === index);
    });

    this.currentIndex = index;
  }

  playVideo(slide) {
    const video = slide.querySelector('.hero-slideshow__video');
    if (video) video.play().catch(() => {});
  }

  pauseVideo(slide) {
    const video = slide.querySelector('.hero-slideshow__video');
    if (video) video.pause();
  }

  startTimer() {
    this.stopTimer();
    this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.speed);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  toggleAutoplay() {
    this.autoRotate = !this.autoRotate;
    this.classList.toggle('is-playing', this.autoRotate);
    if (this.autoRotate) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
  }
}

customElements.define('hero-slideshow', HeroSlideshow);
